import type { APIClient } from '@src/shared/api';
import { prefetchQuery } from '@src/shared/query';
import type { HolidayQueryParams } from './useHolidays';
import { getHolidayYearQueryParams } from './useHolidays';
import { holidaysUrl } from './constants';

export default function prefetchHolidays(
  client: APIClient,
  queryParams: HolidayQueryParams = getHolidayYearQueryParams(),
) {
  prefetchQuery(holidaysUrl, client, {
    queryParams,
  });
}
